var _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraftTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Draft_submission_status",
    "data-name": "Draft submission status",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 23,
    viewBox: "0 0 54 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    fill: "#ececec",
    stroke: "#1e325f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 23,
    rx: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 53,
    height: 22,
    rx: 4,
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Draft",
    transform: "translate(14 16)",
    fill: "#1e325f",
    fontSize: 12,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Draft"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftTag);
export default __webpack_public_path__ + "static/media/draft_tag.f266a89ab23eea0738e80627179ec348.svg";
export { ForwardRef as ReactComponent };